import { cssColorValue, cssSpacing, cursorDisabled, opacityDisabled, semanticColors } from "../../styles/index.mjs";
import { Type } from "../Type/index.mjs";
import styled from "../../styled-components.mjs";
export var TextForLabel = styled(Type).attrs({
  variant: 'viola'
}).withConfig({
  displayName: "TextForLabel",
  componentId: "sc-1wen0a8-0"
})(["position:relative;top:-2px;color:", ";padding-inline-start:", ";padding-inline-end:", ";min-inline-size:0;overflow-wrap:break-word;input:disabled + label &{cursor:", ";opacity:", ";}"], cssColorValue(semanticColors.textBase), cssSpacing('tighter', '12px'), cssSpacing('looser', '24px'), cursorDisabled, opacityDisabled);